import { ChangeDetectorRef, Component, inject, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { TableComponent } from '../../../components/table/table.component';
import { tableModel } from '../../../components/table/model/tableModel';
import { AlertaService } from '../../../services/alerta.service';

@Component({
  selector: 'app-subscription',
  standalone: false,
  templateUrl: './subscription.component.html',
  styleUrl: './subscription.component.css'
})
export class SubscriptionComponent {
 @ViewChild(TableComponent) subscriptionTable : TableComponent | undefined;
  tableModel: tableModel= {
    columnModel:[
      {columnName:'Raz\u00F3n Social',columnValue:'name'},
      {columnName:'RFC',columnValue:'rfc'},
      {columnName:'Tel\u00E9fono',columnValue:'cellPhone'},
      {columnName:'Correo',columnValue:'email'}
    ],
    dataSource: [],
    editButton:true,
    deleteButton: true
  };
  pageIndex: number = 1;
  pageSize: number = 5;
  loading: boolean = false;

  router = inject(Router);
  private cdr = inject(ChangeDetectorRef);
  private alerta = inject(AlertaService);

  constructor(){ }
  
  ngAfterViewInit() {}
  
  ngOnInit(): void {
    this.searchSubscription();
  }

  paginatorEvent(event: any){
    this.pageIndex = (event.pageIndex+1);
    this.pageSize = event.pageSize;
    this.searchSubscription();
  }

  editEvent(event: any){
    this.router.navigate(['/susbscriptions/edit', event.id]);
  }

  deleteEvent(event: any){
    this.alerta.question('Confirmacion', 'Desea eliminar esta subscripcion','Eliminar',{
      onAccept: () => {
        //this.companyService.deleteCompany(event.id).subscribe({
        // next: (response) =>{
            console.log('delete');
        //  }
        //});
    }});
  }

  searchSubscription(){
    /*this.loading = true;
    this.companyService.findAllPageableCompany(this.pageIndex, this.pageSize).subscribe({
      next: (pageable) => {
        this.tableModel.pageSize = pageable.pageSize;
        this.tableModel.totalRecords = pageable.itemsCount;
        this.tableModel.dataSource = pageable.list;
        this.tableModel.pageNumber = pageable.pageNum;
        setTimeout(() => {
          this.companiesTable?.refresh(pageable.list, pageable.itemsCount);
        });
        this.loading = false;
        this.cdr.detectChanges();
      },
      error: (err) => {
        console.error('Error al obtener companias', err);
        this.loading = false;
      }
    });*/
  }
}
